import React from 'react'
import Lottie from 'lottie-react'
import animationData from '../../../assets/animations/privacycloak_loader.json'
import { Box } from '../MaterialExports'

interface MpLoadingIconProps {
  positioned?: boolean
  size?: number | string
}

const MpLoadingIcon = ({ positioned, size = 188 }: MpLoadingIconProps) => {
  const content = (
    <Lottie
      animationData={animationData}
      loop={true}
      style={{ width: size, height: size }}
    />
  )

  return positioned ? (
    <Box
      mt="60px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      {content}
    </Box>
  ) : (
    content
  )
}

export default MpLoadingIcon
